import React, { useEffect, useState } from "react";
import axios from "axios";
import useAdminGuard from "../hooks/useAdminGuard";
import {Link} from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

function FeedbackAdminPage() {
  useAdminGuard(); // 관리자만 접근
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/feedbacks`)
      .then((res) => setFeedbacks(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center mt-8">Loading...</div>;

  return (
      <div className="p-6 text-white bg-gray-900 min-h-screen">
        <Link
            to="/admin"
            className="px-4 py-2 text-sm font-semibold bg-purple-500 text-white rounded-full"
          >
            관리자페이지
          </Link>
        <div className="w-full max-w-2xl mx-auto mt-8 sm:mt-12 px-2 sm:px-0">
          <div className="bg-white dark:bg-gray-900 rounded-xl shadow p-4 sm:p-8">
            <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-blue-700 dark:text-blue-300">Feedback Admin</h2>
            {feedbacks.length === 0 ? (
              <div className="text-gray-500 dark:text-gray-400 text-center">No feedback yet.</div>
            ) : (
              <ul className="space-y-3 sm:space-y-4">
                {feedbacks.map((fb) => (
                  <li key={fb.id} className="p-3 sm:p-4 border rounded-lg bg-blue-50 dark:bg-blue-950">
                    <div className="font-semibold mb-1 text-sm sm:text-base">
                      Type: {fb.type || "N/A"}
                    </div>
                    <div className="text-gray-800 dark:text-gray-200 whitespace-pre-wrap mb-2 text-sm">
                      {fb.feedback_text}
                    </div>
                    <div className="text-xs text-gray-400">{fb.created_at ? new Date(fb.created_at).toLocaleString() : ""}</div>
                    <div className="text-xs text-gray-400">Project: {fb.project} {fb.username && ` | User: ${fb.username}`}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
  );
}

export default FeedbackAdminPage;
